import { render, staticRenderFns } from "./TransactionHistoryHeader.vue?vue&type=template&id=63e4481c&"
import script from "./TransactionHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports